export const DASHBOARD_ID = "dashboardId";